import { Store } from '@ngrx/store';
import { Action } from '@ngrx/store';

export const REFRESH_PENCIL_LIST = 'Refresh Pencil List';
export class RefreshPencils implements Action {
  readonly type = REFRESH_PENCIL_LIST;
  constructor(public payload?: any) {}
}
